import { css } from '@emotion/react';

import brandMark from '~/common/assets/images/hoya-pc-bi.png';
import Flex from '~/common/layouts/Flex';
import { ThemeMode } from '~/common/types/theme.type.ts';

import type { CSSProperties } from 'react';

interface Props {
  /** 테마 모드 */
  theme?: ThemeMode;
  height?: CSSProperties['height'];
}

/**
 * 호야피씨 BI 로고. 자산은 검정 단색 PNG (배경 투명, 521x304).
 * 다크 테마는 invert 필터로 흰색화하고, 라이트 테마는 원본 검정 그대로 사용한다.
 */
function Logo({ theme = ThemeMode.DARK, height = '36px' }: Props) {
  return (
    <Flex css={[styles.logo(height), styles[theme]]} items="center" inline>
      <img alt="호야피씨" src={brandMark} />
    </Flex>
  );
}

const styles = {
  logo: (height: Props['height']) => css`
    img {
      aspect-ratio: 521 / 304;
      height: ${height};
      object-fit: contain;
      display: block;
    }
  `,

  [ThemeMode.LIGHT]: css`
    img {
      filter: none;
    }
  `,

  [ThemeMode.DARK]: css`
    img {
      // 검정 PNG → 완전 흰색화. brightness(0) 으로 RGB 평탄화 후 invert 로 흰색 변환.
      filter: brightness(0) invert(1);
    }
  `,
};

export default Logo;
